export default __webpack_public_path__ + "static/media/empty_person_2.28b8d30f.svg";